export enum UserPaths {
  default = "",
  home = "books",
  book = ':bookId',
  chapters = ":bookId/chapters/:chapterId/pages",
  chaptersWithPageNo = ":bookId/chapters/:chapterId/pages/:pageNo"
}